import { render, staticRenderFns } from "./applicant.vue?vue&type=template&id=27468ca3&scoped=true"
import script from "./applicant.vue?vue&type=script&lang=js"
export * from "./applicant.vue?vue&type=script&lang=js"
import style0 from "./applicant.vue?vue&type=style&index=0&id=27468ca3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27468ca3",
  null
  
)

export default component.exports